import React from 'react';
import { SUPPORT_EMAIL } from '../data/product';
export function Footer() {
  return <footer className="w-full bg-field-deep" data-id="element-137" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-138" data-mp="3ggtwodvnbb34">
        <h3 className="font-display text-2xl font-extrabold tracking-tight text-cream" data-id="element-139" data-mp="32onj8zjvni7d">
          No-Queue <span className="text-willow" data-id="element-140" data-mp="36oo8lf8ildt7">Cricket</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-cream/70" data-id="element-141" data-mp="36n3gdw9oa6yi">
          Every training night planned, so no kid waits in the queue.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-cream/70" data-id="element-142" data-mp="37fsp0xcko14">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex min-h-[44px] items-center px-1 hover:text-cream hover:underline" data-id="element-143" data-mp="3ldkep6r0ggr6">
            {SUPPORT_EMAIL}
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-field-line pt-5 text-xs leading-relaxed text-cream/45" data-id="element-144" data-mp="29y5frxf8retf">
          No-Queue Cricket is a session-planning resource for junior and club
          cricket coaches. It is not affiliated with or endorsed by any cricket
          governing body, league or programme. It does not replace coach
          accreditation, safeguarding or background checks (such as DBS or
          Working With Children checks), first-aid training, or your national
          body&apos;s rules on supervision ratios, protective equipment, bowling
          workload limits and safety. Always follow your national body&apos;s
          guidance and your club&apos;s policies. Results depend on the coach and
          the squad; no specific outcome is guaranteed. © No-Queue Cricket 2026.
          All rights reserved.
        </p>
      </div>
    </footer>;
}